// copy-share.js
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.js-copy-share');
  if (!btn) return;

  const url = btn.dataset.shareUrl;
  if (!url) return;

  navigator.clipboard.writeText(url).then(() => {
    btn.classList.add('is-copied');

    // Optional: temporary feedback
    btn.setAttribute('aria-label', 'Copied!');
    setTimeout(() => {
      btn.classList.remove('is-copied');
      btn.setAttribute('aria-label', 'Copy link');
    }, 2000);
  }).catch(() => {
    alert('Failed to copy link');
  });
});
